<template>
    <div class="col-sm-12 list-content-item mb-2">
        <div class="row">
            <div class="col-auto image-container">
                <avatar-badge :src="displayImage" :raised="false" :size="100"></avatar-badge>
            </div>
            <div class="col">
                <div class="row">
                    <div class="col-lg-9">
                        <h2 class="title" v-text="service.name"></h2>
                    </div>
                    <div class="col-lg-3 text-lg-right text-left mt-sm--2 mt-lg-0">
                        PHP<span class="text-lg" v-text="displayedPrice"></span>
                    </div>
                </div>
                <template v-if="service.type == 'service'">
                    <div class="description" v-text="category.name"></div>
                    <div class="description" v-text="subcategory.name"></div>
                </template>
                <template v-else>
                    <div class="description">Package: </div>
                    <div class="description" v-text="displayedPackageItems"></div>
                </template>

                <div class="text-right">
                    <a href="#" @click.prevent="showService" class="btn btn-sm btn-warning">
                        <i class="fa fa-eye mr-1"></i> View Details
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import moment from "moment";
import { resource } from "@utils/network";

export default {
    name: "ServiceListItem",

    computed: {
        displayImage() {
            return this.service.display_image || resource("images/placeholders/avatar.jpg");
        },
        displayedPrice() {
            return parseFloat(this.service.price || 0).toFixed(2);
        },
        subcategory() {
            return this.service.subcategory || {};
        },
        category() {
            return this.subcategory.category || {};
        },
        displayedPackageItems() {
            return this.service.items
                ? this.service.items.map(item => item.name).join(", ")
                : "";
        },
    },

    methods: {
        showService() {
            this.$emit("show", this.service);
        }
    },
    
    props: {
        service: [Object],
    },

    mounted() {

    }
}
</script>